var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 4H17V2C17 0.897 16.103 0 15 0H9C7.897 0 7 0.897 7 2V4H1V6H2.644L4.347 21.331C4.516 22.852 5.798 24 7.329 24H16.633C18.164 24 19.446 22.853 19.614 21.331L21.317 6H22.999L23 4ZM9 2H15V4H9V2ZM17.626 21.11C17.57 21.617 17.143 22 16.632 22H7.329C6.819 22 6.391 21.617 6.335 21.11L4.656 6H19.306L17.627 21.11H17.626ZM8.043 16.543L10.586 14L8.043 11.457L9.457 10.043L12 12.586L14.543 10.043L15.957 11.457L13.414 14L15.957 16.543L14.543 17.957L12 15.414L9.457 17.957L8.043 16.543Z",
    fill: "#B0AFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.065f2f6075ca9e2f3c7e2f2de8aeab3a.svg";
export { ForwardRef as ReactComponent };